import { HomePageState } from './types';
import { RootState } from '../../rootReducer';

export const selectHomePageState = (state: RootState): HomePageState => {
  return state.homepage;
};
